module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_angle_down-d2055a210a1d48ae37d39c1ebed6a94e.svg";